import React, {useEffect, useState} from 'react';
import {createRoot} from 'react-dom/client';
import PropTypes from "prop-types";
import CsfMembrePageHeading
  from "../csf-membre-page-heading/csf-membre-page-heading";
import CsfMembreSideMenu from "../csf-membre-side-menu/csf-membre-side-menu";
import {
  startLoadingSpinner,
  stopLoadingSpinner
} from "../../csf-ufc-pivotal/includes/utils";
import CsfMembreActivitiesTable from "./CsfMembreActivitiesTable";
import CsfMemberDataLayer from "../utils/CsfMembreDataLayer";
import CsfMembreUtils from "../utils/CsfMembreUtils";
import CsfMemberActivitiesDataLayer from "./CsfMemberActivitiesDataLayer";
import CsfMemberEditActivitiesModal from './CsfMemberEditActivitiesModal';
import CsfMemberDeleteActivitiesModal from './CsfMemberDeleteActivitiesModal';

export function CsfMembreActivities({apiUrl, apiEnv, urlDossierUfc, urlNotifications}) {
  const [accessToken, setAccessToken] = useState('');
  const [member, setMember] = useState({});
  const [ufcCase, setUfcCase] = useState({});
  const [checkedPrintOption, setCheckedPrintOption] = useState('');
  const [dataLayer, setDataLayer] = useState({});
  const [currentActivities, setCurrentActivities] = useState([]);
  const [formerActivities, setFormerActivities] = useState([]);
  const [activitiesDataLayer, setActivitiesDataLayer] = useState({});
  const [ufcHistory, setUfcHistory] = useState({});
  const [selectedActivity, setSelectedActivity] = useState({});
  const [isError, setIsError] = useState(false);
  const [shouldEmptyModal, setShouldEmptyModal] = useState(false);

  useEffect(() => {
    CsfMemberDataLayer.fetchAccessToken(setAccessToken);
  });

  useEffect(() => {
    if (accessToken) {
      setDataLayer(new CsfMemberDataLayer(apiUrl, apiEnv, accessToken));
      setActivitiesDataLayer(new CsfMemberActivitiesDataLayer(apiUrl, apiEnv, accessToken));
    }
  }, [accessToken]);

  useEffect(() => {
    if(CsfMembreUtils.objectIsEmpty(member) && !CsfMembreUtils.objectIsEmpty(dataLayer)) {
      dataLayer.getMember(setMember);
    }
  }, [dataLayer]);

  useEffect(() => {
    if(!CsfMembreUtils.objectIsEmpty(member) && !CsfMembreUtils.objectIsEmpty(dataLayer)) {
      dataLayer.getMemberUFCCase(member?.Contact_Id, setUfcCase);

      // Add modal close listener to reset fields
      $('#membreActivitiesModal-table').on('hidden.bs.modal', handleModalReset);
    }
  }, [member]);

  useEffect(() => {
    if(!CsfMembreUtils.objectIsEmpty(ufcCase) && !CsfMembreUtils.objectIsEmpty(activitiesDataLayer)) {
      activitiesDataLayer.getCurrentActivities(
        ufcCase?.Education_File__Secondary[0]?.REDU_Education_File_Id,
        setCurrentActivities,
        setIsError
      );

      activitiesDataLayer.getFormerActivities(
        ufcCase?.Education_File__Secondary[0]?.REDU_Education_File_Id,
        setFormerActivities,
        setIsError
      )

      if(!CsfMembreUtils.objectIsEmpty(ufcCase?.Education_File__Secondary[0])) {
        dataLayer.getUfcHistoryInfo(ufcCase?.Education_File__Secondary[0]?.Education_File_Id, setUfcHistory);
      }
    }
  }, [ufcCase]);

  function handleModalReset() {
    setSelectedActivity({});
    setShouldEmptyModal(true);
  }

  return (
    <main className="membre activities">

      <div className="content">
        <div className="primary non-print-wrapper">
          <section className="membre__top-section primary-bg mb-5 py-5">
            <p className="text-bold mb-2">Important</p>
            <p dangerouslySetInnerHTML={{__html: window.Drupal.t('membre.activities.warning')}}></p>
          </section>

          {/* main section */}
          <section className="primary-bg">
          {/* sub title */}

          <CsfMembrePageHeading
            title={window.Drupal.t('membre.activities.title')}
            memberName={member["Prénom"] || "" + ' ' + member["Nom"] || ""}
            certificatNumber={member["No_Dossier"] || ""}
          />

          {isError === true && (
            <div className="alert alert-danger" role="alert"
              aria-live="polite">{window.Drupal.t('broker.manager.error.message')}</div>
          )}

          <div className="activities__period activities__period--current">
            <CsfMembreActivitiesTable
              member={member}
              periodTitle={window.Drupal.t('membre.current-period.title')}
              periodSubTitle={dataLayer instanceof CsfMemberDataLayer
                ? dataLayer.getUfcPeriodSubtitle(ufcHistory)
                : ""}
              activities={currentActivities}
              setSelectedActivity={setSelectedActivity}
              collapse={false}
              setCheckedPrintOption={setCheckedPrintOption}
              printId="membre_print_activities_current"
              periodInOrder={
                dataLayer instanceof CsfMemberDataLayer &&
                (dataLayer.getCurrentPeriodHistoryInfo(ufcHistory)?.In_Order === "Oui" ||
                 dataLayer.getCurrentPeriodHistoryInfo(ufcHistory)?.In_Order === "Yes")
              }
              isCurrentPeriodActivity={true}
            />
          </div>

          <div className="activities__period activities__period--previous">
            <CsfMembreActivitiesTable
              member={member}
              periodTitle={window.Drupal.t('membre.previous-period.title')}
              periodSubTitle={dataLayer instanceof CsfMemberDataLayer
                ? dataLayer.getUfcPeriodSubtitle(ufcHistory, false)
                : ""}
              activities={formerActivities}
              setSelectedActivity={setSelectedActivity}
              collapse={true}
              setCheckedPrintOption={setCheckedPrintOption}
              printId="membre_print_activities_previous"
              periodInOrder={
                dataLayer instanceof CsfMemberDataLayer &&
                (dataLayer.getPreviousPeriodHistoryInfo(ufcHistory)?.In_Order === "Oui" ||
                 dataLayer.getPreviousPeriodHistoryInfo(ufcHistory)?.In_Order === "Yes")
              }
              isCurrentPeriodActivity={false}
            />
          </div>
        </section>
      </div>

      <CsfMemberEditActivitiesModal
        modalKey={"table"}
        selectedActivity={selectedActivity}
        ufcCase={ufcCase}
        activitiesDataLayer={activitiesDataLayer}
        shouldEmptyModal={shouldEmptyModal}
        setShouldEmptyModal={setShouldEmptyModal}
      />
      <CsfMemberDeleteActivitiesModal selectedActivity={selectedActivity} activitiesDataLayer={activitiesDataLayer} />

      {/* aside section */}
      <CsfMembreSideMenu
        apiUrl={apiUrl}
        apiEnv={apiEnv}
        urlDossierUfc={urlDossierUfc}
        urlNotifications={urlNotifications}
        checkedPrintOption={checkedPrintOption}
        setCheckedPrintOption={setCheckedPrintOption}
      />
    </div>

    </main>
  );
}

window.addEventListener('DOMContentLoaded', () => {
  const domNode = document.getElementById('CsfMembreActivities');

  if (domNode !== null) {
    const root = createRoot(domNode);

    const apiUrl = domNode.getAttribute("data-api-url");
    const apiEnv = domNode.getAttribute("data-api-env");
    const urlDossierUfc = domNode.getAttribute("data-urlSectionMembreDossierUfc");
    const urlNotifications = domNode.getAttribute("data-urlSectionMembreNotifications");

    root.render(<CsfMembreActivities
      apiUrl={apiUrl}
      apiEnv={apiEnv}
      urlDossierUfc={urlDossierUfc}
      urlNotifications={urlNotifications}
    />)
  }
});

CsfMembreActivities.propTypes = {
  apiUrl: PropTypes.string,
  apiEnv: PropTypes.string,
  urlDossierUfc: PropTypes.string,
  urlNotifications: PropTypes.string,
};
